import { useEffect } from 'react'

const DashboardPage = () => {
  useEffect(() => {}, [])

  return (
    <div>
      <div className="dashboard-container">
        <h2>Dashboard</h2>
      </div>
    </div>
  )
}

export default DashboardPage
